import * as React from 'react'
import { InternalOrExternalLink } from './link'
import { SVGIcon, SVGIconProps } from './svg'

export type ClickableBaseProps = {
  title: string | JSX.Element
  icon?: SVGIconProps['id']
  className?: string
  disabled?: boolean
} & (ClickableButtonProps | ClickableLinkProps)

type ClickableStyleKind = { styleKind: 'link' | 'button' }

export type ClickableLinkProps = {
  elementKind: 'link'
  url: string
  isExternal: boolean
  onClick?: () => void
  htmlAttributes?: React.AnchorHTMLAttributes<HTMLAnchorElement>
}

export type ClickableButtonProps = {
  elementKind: 'button'
  onClick: () => void
  type?: 'button' | 'submit'
  htmlAttributes?: React.ButtonHTMLAttributes<HTMLButtonElement>
}

// Returns a <button> or <a>, with button- or link-styling
export const Clickable = (props: ClickableBaseProps & ClickableStyleKind) => {
  const { icon, styleKind, title } = props
  const iconClass = styleKind === 'link' ? 'link__icon' : 'button__icon'
  const labelClass = styleKind === 'link' ? 'link__label' : 'button__label'
  const clickableInner = (
    <>
      {icon && <SVGIcon id={icon} className={`${iconClass} ${iconClass}--${icon}`} />}
      <span className={labelClass}>{title}</span>
    </>
  )
  return props.elementKind === 'button' ? (
    <button
      {...props.htmlAttributes}
      type={props.type || undefined}
      onClick={props.onClick}
      disabled={props.disabled || false}
      className={props.className}
    >
      {clickableInner}
    </button>
  ) : (
    <InternalOrExternalLink
      {...props.htmlAttributes}
      url={props.url}
      onClick={props.onClick}
      aria-disabled={props.disabled}
      isExternal={props.isExternal}
      className={props.className}
    >
      {clickableInner}
    </InternalOrExternalLink>
  )
}
